export default __webpack_public_path__ + "static/media/no-info.a1ba8936.svg";